module.exports = __webpack_public_path__ + "img/vpengage-logo.787b8110.png";